import { useProductsCollection } from "../../hooks/useProductsCollection";

/**
 * @warning This component is intended to be used only for admin purposes.
 * @description This component is responsible for retrieving the product collection from the CMS.
 * @description This solution compensate the missing logic for retrieving the product collection when the GTM Event send the Cashback from Partner data on procedure finalizations.
 *
 * @return {JSX.Element}
 */
export function ProductCollectionRetriever(): JSX.Element {
  useProductsCollection();

  return <></>;
}
